export class Subscribe {
  id!:string;
  email!:string;
}
